import React from "react";
import {Form} from "react-bootstrap";

const statusOptions = ['Requested', 'Accepted', 'Complete', 'Cancelled'];

class StatusFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderStatusCheckbox = this.renderStatusCheckbox.bind(this);
  }


  handleInputChange(event) {
    //general handlerfor updaing the input value into state.
    //grab values from the input
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    this.props.onFilterChange(name, value);
  }


  renderStatusCheckbox = (key) => {
    const checked = this.props.filterStatuses[key];
    return(
      <Form.Check key={key}
        type='switch'
        value={key}
        label={key}
        id={key}
        checked={checked}
        onChange={this.handleInputChange}
        className="filter-checkbox"
      />
    )
  }


  render() {
    return (
      <Form className="filter" onSubmit={this.handleSubmit}>
        <Form.Group>     
          <Form.Label className="pt-2">Status:</Form.Label>
            <div className="filter-container">
              {statusOptions.map(this.renderStatusCheckbox)}      
            </div>
        </Form.Group>
      </Form>
    );
  }
}

export default StatusFilter;
